import React from 'react';

import { ComponentsTable } from '../components/ComponentsTable/ComponentsTable';
import { useUsers } from '../hooks/useUsers';
import { useSharedComponents } from '../hooks/useSharedComponents';

import type { FC } from 'react';

export const Components: FC = () => {
  const { data: users = [] } = useUsers();
  const { data: components = [], isLoading } = useSharedComponents();

  return (
    <ComponentsTable
      components={components}
      loading={isLoading}
      users={users}
    />
  );
};
